// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.batchApplicationOfLaborTemplates {
  height: 100vh;
  background-color: #f3f4f6;
}
.batchApplicationOfLaborTemplates .header {
  width: 80%;
  margin: auto;
  margin-top: 60px;
  display: flex;
  align-content: space-between;
}
.batchApplicationOfLaborTemplates .header .leftContainer .title {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 38px;
  color: #333333;
}
.batchApplicationOfLaborTemplates .header .leftContainer .subTitle {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #868686;
}
.batchApplicationOfLaborTemplates .header .rightContainer {
  margin-left: auto;
}
.batchApplicationOfLaborTemplates .header .rightContainer .applicableButtonGreen {
  display: flex;
  align-items: center;
  padding: 14px 16px;
  gap: 8px;
  height: 50px;
  width: 151px;
  background: #ffffff;
  border: 1px solid #49ae9e;
  border-radius: 8px;
  color: black;
  padding-top: 4px;
  cursor: default;
}
.batchApplicationOfLaborTemplates .header .rightContainer .applicableButtonGreen .textLabel {
  color: #49ae9e;
  display: inline-block;
  position: relative;
  left: 10px;
  top: 5px;
}
.batchApplicationOfLaborTemplates .header .rightContainer .applicableButtonGreen .image {
  height: 24px;
  display: inline-block;
  position: relative;
  top: 5px;
}
.batchApplicationOfLaborTemplates .content {
  width: 80%;
  margin: auto;
  margin-top: 26px;
  background: #ffffff;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
}
.batchApplicationOfLaborTemplates .content .leftContainer {
  width: 70%;
  display: inline-block;
  border-right: 1px solid #f2f2f2;
}
.batchApplicationOfLaborTemplates .content .leftContainer .dropDownWrapper {
  width: 90%;
  padding-bottom: 20px;
}
.batchApplicationOfLaborTemplates .content .rightContainer {
  width: 30%;
  display: inline-block;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/screens/batch-application-of-labor-templates/BatchApplicationOfLaborTemplates.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,yBAAA;AACJ;AACI;EACI,UAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,4BAAA;AACR;AAEY;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAAhB;AAGY;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AADhB;AAKQ;EACI,iBAAA;AAHZ;AAKY;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AAHhB;AAKgB;EACI,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;AAHpB;AAKgB;EACI,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,QAAA;AAHpB;AASI;EACI,UAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,4CAAA;EACA,kBAAA;AAPR;AAQQ;EACI,UAAA;EACA,qBAAA;EACA,+BAAA;AANZ;AAQY;EACI,UAAA;EACA,oBAAA;AANhB;AASQ;EACI,UAAA;EACA,qBAAA;EACA,YAAA;AAPZ","sourcesContent":[".batchApplicationOfLaborTemplates {\n    height: 100vh;\n    background-color: #f3f4f6;\n\n    .header {\n        width: 80%;\n        margin: auto;\n        margin-top: 60px;\n        display: flex;\n        align-content: space-between;\n\n        .leftContainer {\n            .title {\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 28px;\n                line-height: 38px;\n                color: #333333;\n            }\n\n            .subTitle {\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 400;\n                font-size: 14px;\n                line-height: 20px;\n                color: #868686;\n            }\n        }\n\n        .rightContainer {\n            margin-left: auto;\n\n            .applicableButtonGreen{\n                display: flex;\n                align-items: center;\n                padding: 14px 16px;\n                gap: 8px;\n                height:50px;\n                width: 151px;\n                background: #ffffff;\n                border: 1px solid #49ae9e;\n                border-radius: 8px;\n                color: black;\n                padding-top: 4px;\n                cursor: default;\n\n                .textLabel {\n                    color: #49ae9e;\n                    display: inline-block;\n                    position: relative;\n                    left: 10px;\n                    top:5px;\n                }\n                .image {\n                    height: 24px;\n                    display: inline-block;\n                    position: relative;\n                    top:5px;\n                }\n            }\n        }\n    }\n\n    .content {\n        width: 80%;\n        margin: auto;\n        margin-top: 26px;\n        background: #ffffff;\n        box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);\n        border-radius: 8px;\n        .leftContainer {\n            width: 70%;\n            display: inline-block;\n            border-right: 1px solid #f2f2f2;\n\n            .dropDownWrapper {\n                width: 90%; \n                padding-bottom: 20px;\n            }\n        }\n        .rightContainer {\n            width: 30%;\n            display: inline-block;\n            height: 100%;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
